import { useState, useEffect, useCallback } from 'react'
import { useOptionService } from 'hooks/useOptionService'

export const useFormDescricaoVestigioBalistico = ({ formDescricaoTecnica, tipoExame, descricaoDuplicada }) => {
  const optionService = useOptionService()

  // #region useState options lists and loading indicators
  const [tiposArmaDeFogo, setTiposArmaDeFogo] = useState([])
  const [processandoTiposArmaDeFogo, setProcessandoTiposArmaDeFogo] = useState(false)
  const [marcasArmaDeFogo, setMarcasArmaDeFogo] = useState([])
  const [processandoMarcasArmaDeFogo, setProcessandoMarcasArmaDeFogo] = useState(false)
  const [modelosArmaDeFogo, setModelosArmaDeFogo] = useState([])
  const [modelosArmaDeFogoFiltrados, setModelosArmaDeFogoFiltrados] = useState([])
  const [processandoModelosArmaDeFogo, setProcessandoModelosArmaDeFogo] = useState(false)
  const [calibresNominais, setCalibresNominais] = useState([])
  const [processandoCalibresNominais, setProcessandoCalibresNominais] = useState(false)
  const [calibresNominaisCartucho, setCalibresNominaisCartucho] = useState([])
  const [processandoCalibresNominaisCartucho, setProcessandoCalibresNominaisCartucho] = useState(false)
  const [calibresCartuchoVariacao, setCalibresCartuchoVariacao] = useState([])
  const [processandoCalibresCartuchosVariacao, setProcessandoCalibresCartuchosVariacao] = useState(false)
  const [calibresCartuchosVariacaoFiltrados, setCalibresCartuchosVariacaoFiltrados] = useState([])
  const [locaisFabricacao, setLocaisFabricacao] = useState([])
  const [processandoLocaisFabricacao, setProcessandoLocaisFabricacao] = useState(false)
  const [sistemasDePercussao, setSistemasDePercussao] = useState([])
  const [processandoSistemasDePercussao, setProcessandoSistemasDePercussao] = useState(false)
  const [sistemasDeCarregamento, setSistemasDeCarregamento] = useState([])
  const [processandoSistemasDeCarregamento, setProcessandoSistemasDeCarregamento] = useState(false)
  const [sistemasDeFuncionamento, setSistemasDeFuncionamento] = useState([])
  const [processandoSistemasDeFuncionamento, setProcessandoSistemasDeFuncionamento] = useState(false)
  const [tiposAlmaDeCano, setTiposAlmaDeCano] = useState([])
  const [processandoTiposAlmaDeCano, setProcessandoTiposAlmaDeCano] = useState(false)
  const [tiposAcabamentoArmaDeFogo, setTiposAcabamentoArmaDeFogo] = useState([])
  const [processandoTiposAcabamentoArmaDeFogo, setProcessandoTiposAcabamentoArmaDeFogo] = useState(false)
  const [numeracoesSerie, setNumeracoesSerie] = useState([])
  const [processandoNumeracoesSerie, setProcessandoNumeracoesSerie] = useState(false)
  const [locaisGravacoesNumeracaoDeSerie, setLocaisGravacoesNumeracaoDeSerie] = useState([])
  const [locaisGravacoesNumeracaoDeMontagem, setLocaisGravacoesNumeracaoDeMontagem] = useState([])
  const [processandoLocaisGravacoesNumeracaoDeSerie, setProcessandoLocaisGravacoesNumeracaoDeSerie] = useState(false)
  const [processandoLocaisGravacoesNumeracaoDeMontagem, setProcessandoLocaisGravacoesNumeracaoDeMontagem] = useState(false)
  const [tiposCarregadores, setTiposCarregadores] = useState([])
  const [processandoTiposCarregadores, setProcessandoTiposCarregadores] = useState(false)
  const [mecanismosDisparo, setMecanismosDisparo] = useState([])
  const [processandoMecanismosDisparo, setProcessandoMecanismosDisparo] = useState(false)
  const [empunhaduras, setEmpunhaduras] = useState([])
  const [processandoEmpunhaduras, setProcessandoEmpunhaduras] = useState(false)
  const [coronhas, setCoronhas] = useState([])
  const [processandoCoronhas, setProcessandoCoronhas] = useState(false)
  const [telhas, setTelhas] = useState([])
  const [processandoTelhas, setProcessandoTelhas] = useState(false)
  const [guardasMao, setGuardasMao] = useState([])
  const [processandoGuardasMao, setProcessandoGuardasMao] = useState(false)
  const [gravacoes, setGravacoes] = useState([])
  const [processandoGravacoes, setProcessandoGravacoes] = useState(false)
  const [tiposTambores, setTiposTambores] = useState([])
  const [processandoTiposTambores, setProcessandoTiposTambores] = useState(false)
  const [fabricantesCartucho, setFabricantesCartucho] = useState([])
  const [processandoFabricantesCartucho, setProcessandoFabricantesCartucho] = useState(false)
  const [capsulasEspoletamento, setCapsulasEspoletamento] = useState([])
  const [capsulasEspoletamentoFiltrados, setCapsulasEspoletamentoFiltrados] = useState([])
  const [tiposProjeteis, setTiposProjeteis] = useState([])
  const [tiposProjeteisFiltrados, setTiposProjeteisFiltrados] = useState([])
  const [processandoTiposProjeteis, setProcessandoTiposProjeteis] = useState(false)
  const [tiposEstojos, setTiposEstojos] = useState([])
  const [tiposEstojosFiltrados, setTiposEstojosFiltrados] = useState([])
  const [processandoTiposEstojos, setProcessandoTiposEstojos] = useState(false)
  const [especiesElementoMunicao, setEspeciesElementoMunicao] = useState([])
  const [processandoEspeciesElementoMunicao, setProcessandoEspeciesElementoMunicao] = useState(false)
  const [ressaltosCavados, setRessaltosCavados] = useState([])
  const [ressaltosCavadosFiltrados, setRessaltosCavadosFiltrados] = useState([])
  const [processandoRessaltosCavados, setProcessandoRessaltosCavados] = useState(false)
  const [tiposRaiamentos, setTiposRaiamentos] = useState([])
  const [processandoTiposRaiamentos, setProcessandoTiposRaiamentos] = useState(false)
  const [tiposElementoRecarga, setTiposElementoRecarga] = useState([])
  const [processandoTiposElementoRecarga, setProcessandoTiposElementoRecarga] = useState(false)
  const [estadosConservacao, setEstadosConservacao] = useState([])
  const [processandoEstadosConservacao, setProcessandoEstadosConservacao] = useState(false)

  // Visibility flags for fields
  const [ocultarCalibreNominal, setOcultarCalibreNominal] = useState(false)
  const [ocultarCalibreCompativel, setOcultarCalibreCompativel] = useState(false)
  const [ocultarLocaisGravacoesNumeracaoDeSerie, setOcultarLocaisGravacoesNumeracaoDeSerie] = useState(false)
  const [ocultarLocaisGravacoesNumeracaoDeMontagem, setOcultarLocaisGravacoesNumeracaoDeMontagem] = useState(false)
  const [ocultarTambor, setOcultarTambor] = useState(false)
  const [ocultarCarregador, setOcultarCarregador] = useState(false)
  const [ocultarCoronha, setOcultarCoronha] = useState(false)
  const [ocultarTelha, setOcultarTelha] = useState(false)
  // #endregion

  const getObjetoPeloNome = (lista, nome) => {
    let objetoResultado = null
    if (lista) {
      lista.forEach((objeto) => {
        if (objeto?.nome?.toUpperCase() === nome?.toUpperCase()) {
          objetoResultado = objeto
        }
      })
    }
    return objetoResultado
  }

  // #region fetch functions
  const fetchTiposElementosRecarga = useCallback(async () => {
    const response = await optionService.listarOpcoesDeModeloAsync('TIPO_ELEMENTO_RECARGA', setProcessandoTiposElementoRecarga)
    setTiposElementoRecarga(response || [])
  }, [])
  const fetchTiposRaiamentos = useCallback(async () => {
    const response = await optionService.listarOpcoesDeModeloAsync('TIPO_RAIAMENTO', setProcessandoTiposRaiamentos)
    setTiposRaiamentos(response || [])
  }, [])
  const fetchRessaltosCavados = useCallback(async () => {
    const response = await optionService.listarOpcoesDeModeloAsync('RESSALTOS_E_CAVADOS_ELEMENTO_MUNICAO', setProcessandoRessaltosCavados)
    setRessaltosCavados(response || [])
  }, [])
  const fetchEspeciesElementoMunicao = useCallback(async () => {
    const response = await optionService.listarOpcoesDeModeloAsync('ESPECIE_ELEMENTO_MUNICAO', setProcessandoEspeciesElementoMunicao)
    setEspeciesElementoMunicao(response || [])
  }, [])
  const fetchCapsulasEspoletamento = useCallback(async () => {
    const response = await optionService.listarOpcoesDeModeloAsync('CAPSULA_ESPOLETAMENTO_CARTUCHO', setProcessandoTiposArmaDeFogo)
    setCapsulasEspoletamento(response || [])
  }, [])
  const fetchTiposEstojos = useCallback(async () => {
    const response = await optionService.listarOpcoesDeModeloAsync('TIPO_ESTOJO_CARTUCHO', setProcessandoTiposArmaDeFogo)
    setTiposEstojos(response || [])
  }, [])
  const fetchTiposProjeteis = useCallback(async () => {
    const response = await optionService.listarOpcoesDeModeloAsync('TIPO_PROJETIL_CARTUCHO', setProcessandoTiposArmaDeFogo)
    setTiposProjeteis(response || [])
  }, [])
  const fetchTiposArmaDeFogo = useCallback(async () => {
    const response = await optionService.listarOpcoesDeModeloAsync('TIPO_ARMA_DE_FOGO', setProcessandoTiposArmaDeFogo)
    setTiposArmaDeFogo(response || [])
  }, [])
  const fetchTiposTambores = useCallback(async () => {
    const response = await optionService.listarOpcoesDeModeloAsync('TIPO_TAMBOR_ARMA_DE_FOGO', setProcessandoTiposTambores)
    setTiposTambores(response || [])
  }, [])
  const fetchMarcasArmaDeFogo = useCallback(async () => {
    const response = await optionService.listarOpcoesDeModeloAsync('MARCA_ARMA_DE_FOGO', setProcessandoMarcasArmaDeFogo)
    setMarcasArmaDeFogo(response || [])
  }, [])
  const fetchModelosArmaDeFogo = useCallback(async () => {
    const response = await optionService.listarOpcoesDeModeloAsync('MODELO_ARMA_DE_FOGO', setProcessandoModelosArmaDeFogo)
    setModelosArmaDeFogo(response || [])
  }, [])
  const fetchCalibresNominaisArmaDeFogo = useCallback(async () => {
    const response = await optionService.listarOpcoesDeModeloAsync('CALIBRE_NOMINAL_ARMA_DE_FOGO', setProcessandoCalibresNominais)
    setCalibresNominais(response || [])
  }, [])
  const fetchLocaisFabricacaoArmaDeFogo = useCallback(async () => {
    const response = await optionService.listarOpcoesDeModeloAsync('LOCAL_FABRICACAO_ARMA_DE_FOGO', setProcessandoLocaisFabricacao)
    setLocaisFabricacao(response || [])
  }, [])
  const fetchSistemasDePercussaoArmaDeFogo = useCallback(async () => {
    const response = await optionService.listarOpcoesDeModeloAsync('SISTEMA_PERCUSSAO_ARMA_DE_FOGO', setProcessandoSistemasDePercussao)
    setSistemasDePercussao(response || [])
  }, [])
  const fetchSistemasDeCarregamentoArmaDeFogo = useCallback(async () => {
    const response = await optionService.listarOpcoesDeModeloAsync('SISTEMA_CARREGAMENTO_ARMA_DE_FOGO', setProcessandoSistemasDeCarregamento)
    setSistemasDeCarregamento(response || [])
  }, [])
  const fetchSistemasDeFuncionamentoArmaDeFogo = useCallback(async () => {
    const response = await optionService.listarOpcoesDeModeloAsync('SISTEMA_FUNCIONAMENTO_ARMA_DE_FOGO', setProcessandoSistemasDeFuncionamento)
    setSistemasDeFuncionamento(response || [])
  }, [])
  const fetchTiposAlmaDeCano = useCallback(async () => {
    const response = await optionService.listarOpcoesDeModeloAsync('TIPO_ALMA_DO_CANO_ARMA_DE_FOGO', setProcessandoTiposAlmaDeCano)
    setTiposAlmaDeCano(response || [])
  }, [])
  const fetchTiposAcabamentoArmaDeFogo = useCallback(async () => {
    const response = await optionService.listarOpcoesDeModeloAsync('TIPO_ACABAMENTO_ARMA_DE_FOGO', setProcessandoTiposAcabamentoArmaDeFogo)
    setTiposAcabamentoArmaDeFogo(response || [])
  }, [])
  const fetchNumeracoesSerie = useCallback(async () => {
    const response = await optionService.listarOpcoesDeModeloAsync('NUMERACAO_DE_SERIE_ARMA_DE_FOGO', setProcessandoNumeracoesSerie)
    setNumeracoesSerie(response || [])
  }, [])
  const fetchLocaisGravacaoNumeracaoDeSerie = useCallback(async () => {
    const response = await optionService.listarOpcoesDeModeloAsync('LOCAL_GRAVACAO_NUMERACAO_DE_SERIE_ARMA_DE_FOGO', setProcessandoLocaisGravacoesNumeracaoDeSerie)
    setLocaisGravacoesNumeracaoDeSerie(response || [])
  }, [])
  const fetchLocaisGravacaoNumeracaoDeMontagem = useCallback(async () => {
    const response = await optionService.listarOpcoesDeModeloAsync('LOCAL_GRAVACAO_NUMERACAO_DE_MONTAGEM_ARMA_DE_FOGO', setProcessandoLocaisGravacoesNumeracaoDeMontagem)
    setLocaisGravacoesNumeracaoDeMontagem(response || [])
  }, [])
  const fetchTiposCarregadores = useCallback(async () => {
    const response = await optionService.listarOpcoesDeModeloAsync('TIPO_CARREGADOR_ARMA_DE_FOGO', setProcessandoTiposCarregadores)
    setTiposCarregadores(response || [])
  }, [])
  const fetchMecanismosDisparo = useCallback(async () => {
    const response = await optionService.listarOpcoesDeModeloAsync('TIPO_MECANISMO_DISPARO_ARMA_DE_FOGO', setProcessandoMecanismosDisparo)
    setMecanismosDisparo(response || [])
  }, [])
  const fetchEmpunhaduras = useCallback(async () => {
    const response = await optionService.listarOpcoesDeModeloAsync('TIPO_EMPUNHADURA_ARMA_DE_FOGO', setProcessandoEmpunhaduras)
    setEmpunhaduras(response || [])
  }, [])
  const fetchCoronhas = useCallback(async () => {
    const response = await optionService.listarOpcoesDeModeloAsync('TIPO_CORONHA_ARMA_DE_FOGO', setProcessandoCoronhas)
    setCoronhas(response || [])
  }, [])
  const fetchTelhas = useCallback(async () => {
    const response = await optionService.listarOpcoesDeModeloAsync('TIPO_TELHA_ARMA_DE_FOGO', setProcessandoTelhas)
    setTelhas(response || [])
  }, [])
  const fetchGuardasMao = useCallback(async () => {
    const response = await optionService.listarOpcoesDeModeloAsync('TIPO_GUARDA_MAO_ARMA_DE_FOGO', setProcessandoGuardasMao)
    setGuardasMao(response || [])
  }, [])
  const fetchGravacoes = useCallback(async () => {
    const response = await optionService.listarOpcoesDeModeloAsync('TIPO_GRAVACAO_ARMA_DE_FOGO', setProcessandoGravacoes)
    setGravacoes(response || [])
  }, [])
  const fetchCalibresNominaisCartucho = useCallback(async () => {
    const response = await optionService.listarOpcoesDeModeloAsync('CALIBRE_NOMINAL_CARTUCHO', setProcessandoCalibresNominaisCartucho)
    setCalibresNominaisCartucho(response || [])
  }, [])
  const fetchCalibresCartuchosVariacao = useCallback(async () => {
    const response = await optionService.listarOpcoesDeModeloAsync('CALIBRE_CARTUCHO_VARIACAO', setProcessandoCalibresCartuchosVariacao)
    setCalibresCartuchoVariacao(response || [])
  }, [])
  const fetchFabricantesCartucho = useCallback(async () => {
    const response = await optionService.listarOpcoesDeModeloAsync('FABRICANTE_CARTUCHO', setProcessandoFabricantesCartucho)
    setFabricantesCartucho(response || [])
  }, [])
  const fetchEstadosConservacao = useCallback(async () => {
    const response = await optionService.listarOpcoesDeModeloAsync('ESTADO_CONSERVACAO_ARMA_DE_FOGO', setProcessandoEstadosConservacao)
    setEstadosConservacao(response || [])
  }, [])
  // #endregion

  useEffect(() => {
    setModelosArmaDeFogoFiltrados(modelosArmaDeFogo)
  }, [modelosArmaDeFogo])

  useEffect(() => {
    fetchTiposElementosRecarga()
    fetchTiposRaiamentos()
    fetchRessaltosCavados()
    fetchEspeciesElementoMunicao()
    fetchCalibresCartuchosVariacao()
    fetchCalibresNominaisCartucho()
    fetchTiposArmaDeFogo()
    fetchMarcasArmaDeFogo()
    fetchModelosArmaDeFogo()
    fetchCalibresNominaisArmaDeFogo()
    fetchLocaisFabricacaoArmaDeFogo()
    fetchSistemasDePercussaoArmaDeFogo()
    fetchSistemasDeCarregamentoArmaDeFogo()
    fetchSistemasDeFuncionamentoArmaDeFogo()
    fetchLocaisGravacaoNumeracaoDeSerie()
    fetchLocaisGravacaoNumeracaoDeMontagem()
    fetchTiposCarregadores()
    fetchMecanismosDisparo()
    fetchEmpunhaduras()
    fetchCoronhas()
    fetchTelhas()
    fetchGuardasMao()
    fetchGravacoes()
    fetchTiposTambores()
    fetchFabricantesCartucho()
    fetchCapsulasEspoletamento()
    fetchTiposEstojos()
    fetchTiposProjeteis()
    fetchNumeracoesSerie()
    fetchTiposAlmaDeCano()
    fetchTiposAcabamentoArmaDeFogo()
    fetchEstadosConservacao()
  }, [
    fetchTiposElementosRecarga,
    fetchTiposRaiamentos,
    fetchRessaltosCavados,
    fetchEspeciesElementoMunicao,
    fetchCalibresCartuchosVariacao,
    fetchCalibresNominaisCartucho,
    fetchTiposArmaDeFogo,
    fetchMarcasArmaDeFogo,
    fetchModelosArmaDeFogo,
    fetchCalibresNominaisArmaDeFogo,
    fetchLocaisFabricacaoArmaDeFogo,
    fetchSistemasDePercussaoArmaDeFogo,
    fetchSistemasDeCarregamentoArmaDeFogo,
    fetchSistemasDeFuncionamentoArmaDeFogo,
    fetchLocaisGravacaoNumeracaoDeSerie,
    fetchLocaisGravacaoNumeracaoDeMontagem,
    fetchTiposCarregadores,
    fetchMecanismosDisparo,
    fetchEmpunhaduras,
    fetchCoronhas,
    fetchTelhas,
    fetchGuardasMao,
    fetchGravacoes,
    fetchTiposTambores,
    fetchFabricantesCartucho,
    fetchCapsulasEspoletamento,
    fetchTiposEstojos,
    fetchTiposProjeteis,
    fetchNumeracoesSerie,
    fetchTiposAlmaDeCano,
    fetchTiposAcabamentoArmaDeFogo,
    fetchEstadosConservacao,
  ])

  // #region conditional fill logic
  useEffect(() => {
    if (!descricaoDuplicada) {
      if (
        formDescricaoTecnica.formState.values.tipo &&
        formDescricaoTecnica.formState.values.tipoFabricacao?.toUpperCase() !== 'ARTESANAL'
      ) {
        switch (formDescricaoTecnica.formState.values.tipo?.toUpperCase()) {
          case 'REVÓLVER': {
            const sistemaPercussaoDefault = getObjetoPeloNome(sistemasDePercussao, 'intrínseca')
            const sistemaCarregamentoDefault = getObjetoPeloNome(sistemasDeCarregamento, 'De retrocarga')
            const almaCanoDefault = getObjetoPeloNome(tiposAlmaDeCano, 'raiada')
            const tipoTamborDefault = getObjetoPeloNome(tiposTambores, 'reversível')
            const mecanismoDisparoDefault = getObjetoPeloNome(mecanismosDisparo, 'Movimento duplo')

            formDescricaoTecnica.setFormState((prevState) => ({
              ...prevState,
              values: {
                ...prevState.values,
                sisPercs: sistemaPercussaoDefault ? [sistemaPercussaoDefault] : [],
                sisCarrs: sistemaCarregamentoDefault ? [sistemaCarregamentoDefault] : [],
                almaCanos: almaCanoDefault ? [almaCanoDefault] : [],
                tambores: tipoTamborDefault ? [tipoTamborDefault] : [],
                sistemaFuncionamento: 'De repetição não automática',
                mecanDisps: mecanismoDisparoDefault ? [mecanismoDisparoDefault] : [],
                calibreCompativel: null,
                coronhas: null,
                coronhaInput: null,
                telhas: null,
                telhaInput: null,
                carregadores: [],
              },
            }))
            setOcultarCalibreNominal(false)
            setOcultarCalibreCompativel(true)
            setOcultarLocaisGravacoesNumeracaoDeMontagem(false)
            setOcultarLocaisGravacoesNumeracaoDeSerie(false)
            setOcultarTambor(false)
            setOcultarCarregador(true)
            setOcultarCoronha(true)
            setOcultarTelha(true)
            break
          }
          case 'PISTOLA': {
            const sistemaPercussaoDefault = getObjetoPeloNome(sistemasDePercussao, 'intrínseca')
            const sistemaCarregamentoDefault = getObjetoPeloNome(sistemasDeCarregamento, 'De retrocarga')
            const almaCanoDefault = getObjetoPeloNome(tiposAlmaDeCano, 'raiada')
            const mecanismoDisparoDefault = getObjetoPeloNome(mecanismosDisparo, 'Movimento duplo')

            formDescricaoTecnica.setFormState((prevState) => ({
              ...prevState,
              values: {
                ...prevState.values,
                sisPercs: sistemaPercussaoDefault ? [sistemaPercussaoDefault] : [],
                sisCarrs: sistemaCarregamentoDefault ? [sistemaCarregamentoDefault] : [],
                almaCanos: almaCanoDefault ? [almaCanoDefault] : [],
                sistemaFuncionamento: 'De repetição semiautomática',
                mecanDisps: mecanismoDisparoDefault ? [mecanismoDisparoDefault] : [],
                calibreNominal: null,
                calibreCompativel: null,
                tambores: null,
                tamborInput: null,
                coronhas: null,
                coronhaInput: null,
                telha: null,
                telhaInput: null,
                carregadores: [],
              },
            }))
            setOcultarCalibreNominal(false)
            setOcultarCalibreCompativel(true)
            setOcultarLocaisGravacoesNumeracaoDeMontagem(false)
            setOcultarLocaisGravacoesNumeracaoDeSerie(false)
            setOcultarTambor(true)
            setOcultarCarregador(false)
            setOcultarCoronha(true)
            setOcultarTelha(true)
            break
          }
          case 'ESPINGARDA': {
            const almaCanoDefault = getObjetoPeloNome(tiposAlmaDeCano, 'lisa')

            formDescricaoTecnica.setFormState((prevState) => ({
              ...prevState,
              values: {
                ...prevState.values,
                almaCanos: almaCanoDefault ? [almaCanoDefault] : [],
                sistemaFuncionamento: 'De tiro unitário simples',
                calibreNominal: null,
                calibreCompativel: null,
                mecanDisps: [],
                tambores: null,
                tamborInput: null,
                coronhas: null,
                coronhaInput: null,
                telhas: null,
                telhaInput: null,
                sisPercs: [],
                sisCarrs: [],
                carregadores: [],
              },
            }))
            setOcultarCalibreNominal(false)
            setOcultarCalibreCompativel(true)
            setOcultarLocaisGravacoesNumeracaoDeMontagem(false)
            setOcultarLocaisGravacoesNumeracaoDeSerie(false)
            setOcultarTambor(true)
            setOcultarCarregador(false)
            setOcultarCoronha(false)
            setOcultarTelha(false)
            break
          }
          case 'CARABINA':
          case 'RIFLE':
          case 'SUBMETRALHADORA':
          case 'METRALHADORA':
          case 'FUZIL':
            formDescricaoTecnica.setFormState((prevState) => ({
              ...prevState,
              values: {
                ...prevState.values,
                almaCanos: [],
                sistemaFuncionamento: null,
                calibreNominal: null,
                calibreCompativel: null,
                mecanDisps: [],
                tambores: null,
                tamborInput: null,
                coronhas: null,
                coronhaInput: null,
                telhas: null,
                telhaInput: null,
                sisPercs: [],
                sisCarrs: [],
                carregadores: [],
              },
            }))
            setOcultarCalibreNominal(false)
            setOcultarCalibreCompativel(true)
            setOcultarLocaisGravacoesNumeracaoDeMontagem(false)
            setOcultarLocaisGravacoesNumeracaoDeSerie(false)
            setOcultarTambor(true)
            setOcultarCarregador(false)
            setOcultarCoronha(false)
            setOcultarTelha(false)
            break
          case 'GARRUCHA':
          case 'PISTOLÃO':
          case 'SIMULACRO':
          case 'MOSQUETÃO':
            formDescricaoTecnica.setFormState((prevState) => ({
              ...prevState,
              values: {
                ...prevState.values,
                almaCanos: [],
                sistemaFuncionamento: null,
                calibreNominal: null,
                calibreCompativel: null,
                mecanDisps: [],
                tambores: null,
                tamborInput: null,
                coronhas: null,
                coronhaInput: null,
                telhas: null,
                telhaInput: null,
                sisPercs: [],
                sisCarrs: [],
                carregadores: [],
              },
            }))
            setOcultarCalibreNominal(false)
            setOcultarCalibreCompativel(false)
            setOcultarLocaisGravacoesNumeracaoDeMontagem(false)
            setOcultarLocaisGravacoesNumeracaoDeSerie(false)
            setOcultarTambor(true)
            setOcultarCarregador(true)
            setOcultarCoronha(false)
            setOcultarTelha(false)
            break
          case 'ARMA DE BRINQUEDO':
            formDescricaoTecnica.setFormState((prevState) => ({
              ...prevState,
              values: {
                ...prevState.values,
                almaCanos: [],
                sistemaFuncionamento: null,
                calibreNominal: 'Prejudicado',
                calibreCompativel: null,
                mecanDisps: [],
                tambores: null,
                tamborInput: null,
                coronhas: null,
                coronhaInput: null,
                telhas: null,
                telhaInput: null,
                sisPercs: [],
                sisCarrs: [],
                carregadores: [],
              },
            }))
            setOcultarCalibreNominal(false)
            setOcultarCalibreCompativel(false)
            setOcultarLocaisGravacoesNumeracaoDeMontagem(false)
            setOcultarLocaisGravacoesNumeracaoDeSerie(false)
            setOcultarTambor(true)
            setOcultarCarregador(true)
            setOcultarCoronha(false)
            setOcultarTelha(false)
            break
          case 'MARCADOR DE AIRSOFT':
            formDescricaoTecnica.setFormState((prevState) => ({
              ...prevState,
              values: {
                ...prevState.values,
                almaCanos: [],
                sistemaFuncionamento: null,
                calibreNominal: null,
                calibreCompativel: null,
                mecanDisps: [],
                tambores: null,
                tamborInput: null,
                coronhas: null,
                coronhaInput: null,
                telhas: null,
                telhaInput: null,
                sisPercs: [],
                sisCarrs: [],
                carregadores: [],
              },
            }))
            setOcultarCalibreNominal(false)
            setOcultarCalibreCompativel(false)
            setOcultarLocaisGravacoesNumeracaoDeMontagem(false)
            setOcultarLocaisGravacoesNumeracaoDeSerie(false)
            setOcultarTambor(true)
            setOcultarCarregador(false)
            setOcultarCoronha(false)
            setOcultarTelha(false)
            break
          case 'ARMA DE PRESSÃO':
            setOcultarCalibreNominal(false)
            setOcultarCalibreCompativel(false)
            setOcultarLocaisGravacoesNumeracaoDeMontagem(false)
            setOcultarLocaisGravacoesNumeracaoDeSerie(false)
            setOcultarTambor(true)
            setOcultarCarregador(false)
            setOcultarCoronha(false)
            setOcultarTelha(false)
            break
          default:
            setOcultarCalibreNominal(formDescricaoTecnica.formState.values.tipoFabricacao?.toUpperCase() === 'ARTESANAL')
            setOcultarCalibreCompativel(false)
            setOcultarLocaisGravacoesNumeracaoDeMontagem(false)
            setOcultarLocaisGravacoesNumeracaoDeSerie(false)
            setOcultarTambor(false)
            setOcultarCarregador(false)
            setOcultarCoronha(false)
            setOcultarTelha(false)
            break
        }

        const modelosFiltrados = []
        if (formDescricaoTecnica.formState.values.tipoVestigioEspecifico === 'ARMA_DE_FOGO') {
          const tipoSelecionado = getObjetoPeloNome(tiposArmaDeFogo, formDescricaoTecnica.formState.values.tipo)
          if (tipoSelecionado) {
            modelosArmaDeFogo.forEach((ma) => {
              if (ma.id_tipo_arma_de_fogo === tipoSelecionado.id) {
                modelosFiltrados.push(ma)
              }
            })
          }
          const NaoAparente = modelosArmaDeFogo.find((modelo) => modelo.nome === 'Não aparente')
          if (NaoAparente) {
            modelosFiltrados.push(NaoAparente)
          }
          setModelosArmaDeFogoFiltrados([...modelosFiltrados])
        }
      } else {
        setOcultarCalibreNominal(formDescricaoTecnica.formState.values.tipoFabricacao?.toUpperCase() === 'ARTESANAL')
        setOcultarCalibreCompativel(false)
        setOcultarLocaisGravacoesNumeracaoDeMontagem(formDescricaoTecnica.formState.values.tipoFabricacao?.toUpperCase() === 'ARTESANAL')
        setOcultarLocaisGravacoesNumeracaoDeSerie(formDescricaoTecnica.formState.values.tipoFabricacao?.toUpperCase() === 'ARTESANAL')
        setOcultarTambor(
          !['REVÓLVER', 'PRESSÃO', 'AIRSOFT'].includes(formDescricaoTecnica.formState.values.tipo?.toUpperCase())
        )
        setOcultarCarregador(false)
        setOcultarCoronha(false)
        setOcultarTelha(false)
        setModelosArmaDeFogoFiltrados(modelosArmaDeFogo)
      }
    }
  }, [
    formDescricaoTecnica.formState.values.tipo,
    formDescricaoTecnica.formState.values.tipoFabricacao,
    descricaoDuplicada,
    tiposArmaDeFogo,
    modelosArmaDeFogo,
    sistemasDePercussao,
    sistemasDeCarregamento,
    tiposAlmaDeCano,
    tiposTambores,
    mecanismosDisparo,
  ])

  useEffect(() => {
    if (!descricaoDuplicada) {
      if (formDescricaoTecnica.formState.values.tipoFabricacao?.toUpperCase() === 'ARTESANAL') {
        const marcaDefault = 'Fabricação artesanal'
        const localFabricacaoDefault = getObjetoPeloNome(locaisFabricacao, 'Prejudicado')
        const modeloDefault = 'Prejudicado'
        const numeracaoDeSerieDefault = 'Prejudicado'
        const almaCanoDefault = getObjetoPeloNome(tiposAlmaDeCano, 'lisa')
        const sistemaFuncionamentoDefault = 'De tiro unitário simples'
        
        formDescricaoTecnica.setFormState((prevState) => ({
          ...prevState,
          values: {
            ...prevState.values,
            marca: marcaDefault,
            modelo: modeloDefault,
            locFabs: localFabricacaoDefault ? [localFabricacaoDefault] : [],
            sistemaFuncionamento: sistemaFuncionamentoDefault,
            numeracaoDeSerie: numeracaoDeSerieDefault,
            numeracaoDeMontagem: 'Prejudicado',
            calibreNominal: null,
            calibreCompativel: null,
            almaCanos: almaCanoDefault ? [almaCanoDefault] : [],
            mecanDisps: [],
            tambores: null,
            tamborInput: null,
            coronhas: null,
            coronhaInput: null,
            telhas: null,
            telhaInput: null,
            sisPercs: [],
            sisCarrs: [],
            carregadores: [],
            capacidade: null,
            almaMira: 'Ausente',
          },
        }))

        setOcultarCalibreNominal(true)
        setOcultarCalibreCompativel(false)
        setOcultarLocaisGravacoesNumeracaoDeMontagem(true)
        setOcultarLocaisGravacoesNumeracaoDeSerie(true)
        setOcultarTambor(formDescricaoTecnica.formState.values.tipo?.toUpperCase() !== 'REVÓLVER')
        setOcultarCarregador(false)
        setOcultarCoronha(false)
        setOcultarTelha(false)
      } else {
        setOcultarCalibreNominal(false)
        setOcultarCalibreCompativel(true)
        setOcultarLocaisGravacoesNumeracaoDeMontagem(false)
        setOcultarLocaisGravacoesNumeracaoDeSerie(false)
        setOcultarTambor(false)
        setOcultarCarregador(false)
        setOcultarCoronha(false)
        setOcultarTelha(false)
      }
    }
  }, [formDescricaoTecnica.formState.values.tipoFabricacao, descricaoDuplicada, locaisFabricacao, tiposAlmaDeCano])

  useEffect(() => {
    if (!descricaoDuplicada) {
      if (formDescricaoTecnica.formState.values.tipoVestigioEspecifico === 'ARMA_DE_PRESSAO') {
        formDescricaoTecnica.setFormState((prevState) => ({
          ...prevState,
          values: {
            ...prevState.values,
            tipo: 'Arma de pressão',
          },
        }))

        setOcultarCalibreNominal(false)
        setOcultarCalibreCompativel(false)
        setOcultarLocaisGravacoesNumeracaoDeMontagem(false)
        setOcultarLocaisGravacoesNumeracaoDeSerie(false)
        setOcultarTambor(true)
        setOcultarCarregador(false)
        setOcultarCoronha(false)
        setOcultarTelha(false)
      }
    }
  }, [formDescricaoTecnica.formState.values.tipoVestigioEspecifico, descricaoDuplicada])

  useEffect(() => {
    if (!descricaoDuplicada) {
      if (
        ['BALIM', 'BUCHA', 'BALOTE', 'FRAGMENTO DE CHUMBO'].includes(
          formDescricaoTecnica.formState.values.tipo?.toUpperCase()
        ) &&
        formDescricaoTecnica.formState.values.tipoVestigioEspecifico === 'ELEMENTO_MUNICAO'
      ) {
        formDescricaoTecnica.setFormState((prevState) => ({
          ...prevState,
          values: {
            ...prevState.values,
            calibreCompativel: 'Prejudicado',
            medidaComprimento: 'Prejudicado',
            medidaDiametro: 'Prejudicado',
            medidaMassa: null,
            ressaltosCavados: [getObjetoPeloNome(ressaltosCavados, 'Prejudicado')].filter(Boolean),
            tiposRaiamentos: [getObjetoPeloNome(tiposRaiamentos, 'Prejudicado')].filter(Boolean),
          },
        }))
      } else if (formDescricaoTecnica.formState.values.tipoVestigioEspecifico === 'ELEMENTO_MUNICAO') {
        formDescricaoTecnica.setFormState((prevState) => ({
          ...prevState,
          values: {
            ...prevState.values,
            calibreCompativel: null,
            medidaComprimento: null,
            medidaDiametro: null,
            medidaMassa: null,
            ressaltosCavados: [],
            tiposRaiamentos: [],
          },
        }))
      }
    }
  }, [
    formDescricaoTecnica.formState.values.tipo,
    formDescricaoTecnica.formState.values.tipoVestigioEspecifico,
    descricaoDuplicada,
    ressaltosCavados,
    tiposRaiamentos,
  ])

  useEffect(() => {
    if (!descricaoDuplicada) {
      if (
        formDescricaoTecnica.formState.values.tipo?.toUpperCase() === 'ESPOLETA' &&
        formDescricaoTecnica.formState.values.tipoVestigioEspecifico === 'ELEMENTO_RECARGA'
      ) {
        formDescricaoTecnica.setFormState((prevState) => ({
          ...prevState,
          values: {
            ...prevState.values,
            unidadeQuantidade: 'un',
            quantidade: 0,
            unidadesConsumidas: 0,
          },
        }))
      } else if (formDescricaoTecnica.formState.values.tipoVestigioEspecifico === 'ELEMENTO_RECARGA') {
        formDescricaoTecnica.setFormState((prevState) => ({
          ...prevState,
          values: {
            ...prevState.values,
            unidadeQuantidade: null,
            quantidade: 0,
            unidadesConsumidas: 0,
          },
        }))
      }
    }
  }, [
    formDescricaoTecnica.formState.values.tipo,
    formDescricaoTecnica.formState.values.tipoVestigioEspecifico,
    descricaoDuplicada,
  ])

  useEffect(() => {
    if (!descricaoDuplicada) {
      const variacoes = []
      calibresCartuchoVariacao.forEach((variacao) => {
        const calibreNominalSelecionado = getObjetoPeloNome(calibresNominaisCartucho, formDescricaoTecnica.formState.values.calibreNominal)
        if (variacao?.id_calibre_nominal_cartucho === calibreNominalSelecionado?.id) {
          variacoes.push(variacao)
        }
      })
      setCalibresCartuchosVariacaoFiltrados(variacoes)
    }
  }, [
    formDescricaoTecnica.formState.values.calibreNominal,
    calibresCartuchoVariacao,
    calibresNominaisCartucho,
    descricaoDuplicada,
  ])

  useEffect(() => {
    const result = []
    capsulasEspoletamento?.forEach((opcaoCapsula) => {
      let categoriaJaAdicionada = false
      formDescricaoTecnica.formState.values.capsulaEsps?.forEach((c) => {
        result.push(c)
        if (c.categoria === opcaoCapsula.categoria) {
          categoriaJaAdicionada = true
        }
      })
      if (!categoriaJaAdicionada) {
        result.push(opcaoCapsula)
      }
    })
    setCapsulasEspoletamentoFiltrados(result)
  }, [formDescricaoTecnica.formState.values.capsulaEsps, capsulasEspoletamento])

  useEffect(() => {
    const result = []
    tiposEstojos?.forEach((opcaoEstojo) => {
      let categoriaJaAdicionada = false
      formDescricaoTecnica.formState.values.tipoEstojos?.forEach((te) => {
        result.push(te)
        if (te.categoria === opcaoEstojo.categoria) {
          categoriaJaAdicionada = true
        }
      })
      if (!categoriaJaAdicionada) {
        result.push(opcaoEstojo)
      }
    })
    setTiposEstojosFiltrados(result)
  }, [formDescricaoTecnica.formState.values.tipoEstojos, tiposEstojos])

  useEffect(() => {
    const result = []
    tiposProjeteis?.forEach((opcaoProjetil) => {
      let categoriaJaAdicionada = false
      formDescricaoTecnica.formState.values.tiposProjetil?.forEach((tp) => {
        result.push(tp)
        if (tp.categoria === opcaoProjetil.categoria) {
          categoriaJaAdicionada = true
        }
      })
      if (!categoriaJaAdicionada) {
        result.push(opcaoProjetil)
      }
    })
    setTiposProjeteisFiltrados(result)
  }, [formDescricaoTecnica.formState.values.tiposProjetil, tiposProjeteis])

  useEffect(() => {
    const result = []
    ressaltosCavados?.forEach((opcaoRessalto) => {
      let categoriaJaAdicionada = false
      formDescricaoTecnica.formState.values.ressaltosCavados?.forEach((rc) => {
        result.push(rc)
        if (rc.categoria === opcaoRessalto.categoria) {
          categoriaJaAdicionada = true
        }
      })
      if (!categoriaJaAdicionada) {
        result.push(opcaoRessalto)
      }
    })
    setRessaltosCavadosFiltrados(result)
  }, [formDescricaoTecnica.formState.values.ressaltosCavados, ressaltosCavados])
  // #endregion

  // Helper functions for inputs
  const numero = (newValue) => {
    let result = newValue
    result = result.replace(/[^0-9]/g, '') // Remove non-numbers
    result = result.replace(/^0+/g, '')
    if (result.length > 10) {
      result = result.substring(0, 10)
    }
    return result
  }

  const numeroMenorQueUnidades = (newValue) => {
    let result = newValue
    result = result.replace(/[^0-9]/g, '')
    if (result.length > 10) {
      result = result.substring(0, 10)
    }
    if (parseInt(result) > parseInt(formDescricaoTecnica.formState.values.unidades)) {
      result = result.substring(0, result.length - 1)
    }
    return result
  }

  const numeroMenorQueQuantidade = (newValue) => {
    let result = newValue
    result = result.replace(/[^0-9]/g, '')
    if (result.length > 10) {
      result = result.substring(0, 10)
    }
    if (parseInt(result) > parseInt(formDescricaoTecnica.formState.values.quantidade)) {
      result = result.substring(0, result.length - 1)
    }
    return result
  }

  const loading =
    processandoTiposArmaDeFogo ||
    processandoMarcasArmaDeFogo ||
    processandoModelosArmaDeFogo ||
    processandoCalibresNominais ||
    processandoLocaisFabricacao ||
    processandoSistemasDePercussao ||
    processandoSistemasDeCarregamento ||
    processandoSistemasDeFuncionamento ||
    processandoTiposAlmaDeCano ||
    processandoTiposAcabamentoArmaDeFogo ||
    processandoNumeracoesSerie ||
    processandoLocaisGravacoesNumeracaoDeSerie ||
    processandoLocaisGravacoesNumeracaoDeMontagem ||
    processandoTiposCarregadores ||
    processandoMecanismosDisparo ||
    processandoEmpunhaduras ||
    processandoCoronhas ||
    processandoTelhas ||
    processandoGuardasMao ||
    processandoGravacoes ||
    processandoTiposTambores ||
    processandoFabricantesCartucho ||
    processandoCalibresNominaisCartucho ||
    processandoCalibresCartuchosVariacao ||
    processandoEspeciesElementoMunicao ||
    processandoRessaltosCavados ||
    processandoTiposRaiamentos ||
    processandoTiposElementoRecarga ||
    processandoEstadosConservacao

  return {
    tiposArmaDeFogo,
    marcasArmaDeFogo,
    modelosArmaDeFogoFiltrados,
    calibresNominais,
    calibresNominaisCartucho,
    calibresCartuchosVariacaoFiltrados,
    locaisFabricacao,
    sistemasDePercussao,
    sistemasDeCarregamento,
    sistemasDeFuncionamento,
    tiposAlmaDeCano,
    tiposAcabamentoArmaDeFogo,
    numeracoesSerie,
    locaisGravacoesNumeracaoDeSerie,
    locaisGravacoesNumeracaoDeMontagem,
    tiposCarregadores,
    mecanismosDisparo,
    empunhaduras,
    coronhas,
    telhas,
    guardasMao,
    gravacoes,
    tiposTambores,
    fabricantesCartucho,
    capsulasEspoletamentoFiltrados,
    tiposEstojosFiltrados,
    tiposProjeteisFiltrados,
    especiesElementoMunicao,
    ressaltosCavadosFiltrados,
    tiposRaiamentos,
    tiposElementoRecarga,
    estadosConservacao,

    ocultarCalibreNominal,
    ocultarCalibreCompativel,
    ocultarLocaisGravacoesNumeracaoDeSerie,
    ocultarLocaisGravacoesNumeracaoDeMontagem,
    ocultarTambor,
    ocultarCarregador,
    ocultarCoronha,
    ocultarTelha,

    loading,
    numero,
    numeroMenorQueUnidades,
    numeroMenorQueQuantidade,
  }
}
